import React, { ReactElement, useEffect } from 'react'
import Divider from '../../Divider'
import HistoryOverview from './HistoryOverview'
import { ArtData } from '@/database/art'

const HistoryPanel = ({ artData, tabName }: { artData: ArtData | undefined; tabName: string }): ReactElement => {
    useEffect(() => {
        window.location.hash = `#nft-${artData?.tokenId + tabName}#history`
    }, [artData])

    return (
        <div className="panel">
            <Divider />
            <HistoryOverview artData={artData} />
        </div>
    )
}

export default HistoryPanel
